/**
 * Created by Daniela on 23/01/2017.
 */
import { Injectable } from '@angular/core';

import {tanquesStorage, TiposMovimentacoesTanques} from "./data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { BombaNavigationService } from "../../bombas/shared/bomba-navigation.service";
import { BombaService } from "../../bombas/shared/bomba.service";
import { bombasStorage } from "../../bombas/shared/data.service";
import { UtilService } from "../../../shared/services/util.service";

@Injectable()
export class TanqueService {

    constructor(
        private _autocompleteService: AutoCompleteService,
        private _bombaNavigationService: BombaNavigationService,
        private _bombaService: BombaService,
        private _utilService: UtilService
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(tanquesStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(tanquesStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(tanquesStorage + "-new");
    }

    returnToOtherForm(otherForm: string, Response: any) {
        let otherFormObject: any;

        if(Response) {
            if (otherForm === bombasStorage) {
                otherFormObject = this._bombaService.getSessionStorage();
                otherFormObject.tanque = Response;
                this._bombaService.setSessionStorage(otherFormObject);
            }
        }

        this._autocompleteService.clearSessionStorage(tanquesStorage);

        if (otherForm === bombasStorage) {
            otherFormObject = this._bombaService.getSessionStorage();
            if (otherFormObject.id) {
                this._bombaNavigationService.goToEdit(otherFormObject.id);
            } else {
                this._bombaNavigationService.goToNew();
            }
        }
    }

    templateResult = (function(state: any, isCreateNew: boolean) {
        let stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (isCreateNew) {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                } else {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                }
            } else {
                if (state.text) {
                    text = state.text;
                } else {
                    let combustivel: string = '';
                    if (state.combustivel) {
                        combustivel = state.combustivel.combustivel;
                        combustivel = " (" + combustivel + ")";

                        text = state.identificacao.concat(combustivel);
                    }
                }
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));

    getTipoMovimentacaoEntrada() {
        return this.getTipoMovimentacao(1);
    }
    getTipoMovimentacaoSaida() {
        return this.getTipoMovimentacao(2);
    }
    getTipoMovimentacaoEstorno() {
        return this.getTipoMovimentacao(3);
    }
    getTipoMovimentacaoAjuste() {
        return this.getTipoMovimentacao(4);
    }
    getTipoMovimentacaoTransferencia() {
        return this.getTipoMovimentacao(5);
    }

    private getTipoMovimentacao(tipoKey: number) {
        let tipos: any[] = this._utilService.cloneObject(TiposMovimentacoesTanques),
            x: any, lenX: any, tipo: any;

        for (x = 0, lenX = tipos.length; x < lenX; x++) {
            if (tipos[x].Key === tipoKey) {
                tipo = tipos[x];
                break;
            }
        }

        return tipo;
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/shared/tanque.service.ts
 **/